import { FETCHING_STATUS } from 'constants.js';

export const isInit = status => FETCHING_STATUS.INIT === status;
export const isStart = status => FETCHING_STATUS.START === status;
export const isSuccess = status => FETCHING_STATUS.SUCCESS === status;
export const isError = status => FETCHING_STATUS.ERROR === status;
